import { render, staticRenderFns } from "./ConsultationBusiness.vue?vue&type=template&id=d44a6aee&scoped=true&"
import script from "./ConsultationBusiness.vue?vue&type=script&lang=js&"
export * from "./ConsultationBusiness.vue?vue&type=script&lang=js&"
import style0 from "./ConsultationBusiness.vue?vue&type=style&index=0&id=d44a6aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44a6aee",
  null
  
)

export default component.exports